<template>
  <div itemscope itemtype="http://schema.org/Service">
    <meta itemprop="serviceType" content="edo Service"/>
    <v-container>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-card-media
              class="edomargintop"
              alt="Service"
              height="450px"
              :src="require('../assets/service.jpg')">
            </v-card-media>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card class="edomargintop">
            <div itemprop="name">
              <v-card-title primary class="title edoheadlinedark">DER <span
                style="color:#0e71b8"> &nbsp;EDOLOGIC&nbsp;</span> SERVICE – PERFEKT AUF SIE ABGESTIMMT
              </v-card-title>
            </div>
          </v-card>
        </v-flex>
      </v-layout>
      <div itemprop="hasOfferCatalog" itemscope itemtype="http://schema.org/OfferCatalog">
        <v-container fluid grid-list-md>
          <v-layout row wrap justify-space-around>
            <v-flex d-flex xs12 sm12 md4 class="linkedo">
              <div itemprop="itemListElement" itemscope itemtype="http://schema.org/OfferCatalog">
                <a itemprop="url" href="https://edologic.de/service/softwareentwicklung">
                  <router-link :to="'/service/softwareentwicklung'" class="link">
                    <v-card class="edomargintop">
                      <v-card-title primary class="title edoheadlinetext trennung">
              <span itemprop="name">
              SOFTWAREENTWICKLUNG
              </span>
                      </v-card-title>
                      <v-card-text>
                        <div>
                          <i class="fa fa-angle-right fa-2x edocolor" aria-hidden="true"></i>
                          <router-link :to="'/service/softwareentwicklung'" class="edolinkgross">
                            <span>MEHR ERFAHREN</span>
                          </router-link>
                        </div>
                      </v-card-text>
                    </v-card>
                  </router-link>
                </a>
              </div>
            </v-flex>
            <v-flex d-flex xs12 sm12 md4 class="linkedo">
              <div itemprop="itemListElement" itemscope itemtype="http://schema.org/OfferCatalog">
                <a itemprop="url" href="https://edologic.de/service/kreation">
                  <router-link :to="'/service/kreation'" class="link">
                    <v-card class="edomargintop">
                      <v-card-title primary class="title edoheadlinetext">
                      <span itemprop="name">
                        KREATION
                      </span>
                      </v-card-title>
                      <v-card-text>
                        <div>
                          <i class="fa fa-angle-right fa-2x edocolor" aria-hidden="true"></i>
                          <router-link :to="'/service/kreation'" class="edolinkgross">
                            <span>MEHR ERFAHREN</span>
                          </router-link>
                        </div>
                      </v-card-text>
                    </v-card>
                  </router-link>
                </a>
              </div>
            </v-flex>
            <v-flex d-flex xs12 sm12 md4 class="linkedo">
              <div itemprop="itemListElement" itemscope itemtype="http://schema.org/OfferCatalog">
                <a itemprop="url" href="https://edologic.de/service/rechenzentrum">
                  <router-link :to="'/service/rechenzentrum'" class="link">
                    <v-card class="edomargintop">
                      <v-card-title primary class="title edoheadlinetext">
                        <span itemprop="name">
                        RECHENZENTRUM
                        </span>
                      </v-card-title>
                      <v-card-text>
                        <div>
                          <i class="fa fa-angle-right fa-2x edocolor" aria-hidden="true"></i>
                          <router-link :to="'/service/rechenzentrum'" class="edolinkgross">
                            <span>MEHR ERFAHREN</span>
                          </router-link>
                        </div>
                      </v-card-text>
                    </v-card>
                  </router-link>
                </a>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
      <v-layout row wrap>
        <v-container>
          <v-card class="edoabstandfooter">
          </v-card>
        </v-container>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  export default {
    name: 'Service',
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: 'Service – Dienstleistungen der edologic',
      meta: [
        {
          name: 'description',
          content: 'Breites Dienstleistungsangebot aus individueller Softwareentwicklung, Kreation und Rechenzentrum.'
        }]
    },
    data () {
      return {
      }
    },
    methods: {
    },
    mounted () {
      console.log('Service')
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Service.vue